import { render, staticRenderFns } from "./Dns.vue?vue&type=template&id=c1b99198&scoped=true"
import script from "./Dns.vue?vue&type=script&lang=js"
export * from "./Dns.vue?vue&type=script&lang=js"
import style0 from "./Dns.vue?vue&type=style&index=0&id=c1b99198&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b99198",
  null
  
)

export default component.exports